<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <HeroForm @submit-requested="submitRequested"></HeroForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import HeroForm from './HeroForm.vue'

  export default {
  components: { HeroForm },
  methods: {
    ...mapActions('hero', ['postHero']),
    submitRequested (input) {
      this.postHero(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 